import React, { ReactNode } from "react";

import { Flex, Typography } from "components";

interface FormBodyWrapperProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  dataTestId?: string;
}

export const FormBodyWrapper = ({ title, subtitle, children, dataTestId }: FormBodyWrapperProps) => (
  <Flex vertical data-testid={dataTestId}>
    <Typography variant="h1" className="margin-bottom-125">
      {title}
    </Typography>
    <Typography variant="paragraph-m" className="margin-0 margin-bottom-200">
      {subtitle}
    </Typography>
    {children}
  </Flex>
);
